import { makeStyles } from '@mui/styles';
import theme from 'theme';

export const HowDoIUseThisDocumentsUploadSectionStyles = makeStyles({
  howDoIUseThisBox: {
    display: 'flex',
    alignItems: 'center',
    fontWeight: 400,
    color: theme.palette.primary[500],
    marginTop: '1.5rem',
    fontSize: '1.125rem',
  },
  howDoIUseThisIcon: {
    marginRight: '0.5rem',
    width: '1.2rem',
  },
  howDoIUseThisText: {
    color: theme.palette.primary[500],
    cursor: 'pointer',
  },
  tooltip: {
    backgroundColor: theme.palette.black,
    padding: '1rem 2rem',
  },
});
